"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const defaultFormats = {
    date: {
        dateTime: {
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            month: "short",
            year: "numeric",
        },
        dateTimeSecond: {
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            month: "short",
            second: "2-digit",
            year: "numeric",
        },
        default: {
            day: "2-digit",
            month: "short",
            year: "numeric",
        },
    },
    time: {
        justTime: {
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
        },
    },
};
exports.default = defaultFormats;
